/* Art Style Quiz — Art & See free tool (Capitão C, lote 4, 2026-09-12)
   Adaptive this-or-that over REAL catalogue works. No email gate, no external request
   beyond window.ArtSeeCatalog (contract CONTRATO-DADOS.md §2) and the CDN images.

   TASTE MODEL (documented in full in the section's editorial + the lote4 report)
   ---------------------------------------------------------------------------
   A weight vector W over 21 keys grouped in 6 families:
     sg  style group   sg:imp sg:rea sg:bar sg:rom sg:ren sg:mod
     su  subject       su:lan su:por su:bot su:sea su:rel su:arc
     pd  period        pd:old (<=18th) pd:c19 (19th) pd:c20 (1900+)
     tmp palette temp  pa:warm pa:cool        (from row.c hue x saturation x area)
     val palette value pa:light pa:dark       (from row.c lightness x area)
     cx  busy/calm     cx:busy cx:calm        (normalised entropy of the 6 area shares)
   Every work gets a feature map f(row) with each family summing to <= 1.
   Round: user picks X over Y  ->  W[k] += f_X[k] - f_Y[k] for every key;
          evidence[family]     += sum |f_X[k] - f_Y[k]| over that family's keys.
          "Neither" updates evidence at half weight and leaves W untouched.
   Next pair: the family with the lowest evidence/target ratio is the least certain;
          the pair is the two works that separate THAT family most while separating the
          other families least (cross-penalty). Deterministic given the seed in #s=.
   Result: W normalised per family, dot product against 12 archetype prototypes.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-asq]');
  if (!root) return;

  var H = 0, T = 1, A = 2, P = 4, Y = 5, S = 6, J = 7, E = 8, C = 11;
  var ROUNDS = 8;

  /* ------------------------------------------------------------------ maps */
  var SG = {
    Impressionism: 'imp', Post_Impressionism: 'imp', Neo_Impressionism: 'imp',
    Pointillism: 'imp', Divisionism: 'imp', Luminism: 'imp', Cloisonnism: 'imp',
    Realism: 'rea', Naturalism: 'rea', Academicism: 'rea', Neoclassicism: 'rea',
    Biedermeier: 'rea', Orientalism: 'rea', Social_Realism: 'rea', Photorealism: 'rea',
    Baroque: 'bar', Rococo: 'bar', Tenebrism: 'bar',
    Romanticism: 'rom', Symbolism: 'rom', Art_Nouveau_Modern: 'rom',
    Pre_Raphaelite: 'rom', Aestheticism: 'rom', Hudson_River_School: 'rom',
    Northern_Renaissance: 'ren', High_Renaissance: 'ren', Early_Renaissance: 'ren',
    Mannerism_Late_Renaissance: 'ren', Proto_Renaissance: 'ren', Gothic: 'ren',
    Byzantine: 'ren', International_Gothic: 'ren',
    Expressionism: 'mod', Cubism: 'mod', Fauvism: 'mod', Abstract_Art: 'mod',
    Surrealism: 'mod', Futurism: 'mod', Constructivism: 'mod', Suprematism: 'mod',
    Abstract_Expressionism: 'mod', Pop_Art: 'mod', Art_Deco: 'mod', Precisionism: 'mod',
    Magic_Realism: 'mod', Synthetism: 'mod', Minimalism: 'mod', Op_Art: 'mod',
    Color_Field_Painting: 'mod', Kinetic_Art: 'mod'
  };
  SG['Naïve_Art_Primitivism'] = 'mod';

  var SU = {
    landscapes: 'lan', portraits: 'por', botanicals: 'bot',
    seascapes: 'sea', religion: 'rel', architectural: 'arc'
  };

  var FAM = {
    sg: ['sg:imp', 'sg:rea', 'sg:bar', 'sg:rom', 'sg:ren', 'sg:mod'],
    su: ['su:lan', 'su:por', 'su:bot', 'su:sea', 'su:rel', 'su:arc'],
    pd: ['pd:old', 'pd:c19', 'pd:c20'],
    tmp: ['pa:warm', 'pa:cool'],
    val: ['pa:light', 'pa:dark'],
    cx: ['cx:calm', 'cx:busy']
  };
  var FAMS = ['sg', 'su', 'pd', 'tmp', 'val', 'cx'];
  var TARGET = { sg: 3.2, su: 3.2, pd: 2.0, tmp: 1.6, val: 1.6, cx: 1.6 };
  var KEYS = [], KEYFAM = {};
  FAMS.forEach(function (g) { FAM[g].forEach(function (k) { KEYS.push(k); KEYFAM[k] = g; }); });

  /* ----------------------------------------------------------- 12 archetypes
     proto = prototype weight vector. filter = what ArtSeeCatalog.filter gets.
     url   = a collection that already exists (all 12 verified 200 + products). */
  var ARCH = [
    { id: 'impressionist-romantic', name: 'The Impressionist Romantic',
      desc: 'You are drawn to light before line: broken brushwork, gardens at the hour the sun goes soft, weather you can almost feel. The subject matters less to you than the atmosphere it is painted in.',
      proto: { 'sg:imp': 1, 'sg:rom': .4, 'pd:c19': .7, 'su:lan': .5, 'pa:light': .5, 'cx:busy': .4 },
      filter: { style: 'Impressionism', subject: 'landscapes' },
      url: '/collections/style-impressionism/subject_landscapes', label: 'Impressionist landscapes' },
    { id: 'old-master-traditionalist', name: 'The Old-Master Traditionalist',
      desc: 'You trust a painting that took a year to make. Fine detail, sober colour and faces that hold your eye are worth more to you than novelty.',
      proto: { 'sg:ren': 1, 'pd:old': .9, 'su:por': .5, 'pa:dark': .3, 'cx:calm': .3 },
      filter: { style: 'Northern_Renaissance' },
      url: '/collections/style-northern-renaissance', label: 'Northern Renaissance paintings' },
    { id: 'dutch-golden-age', name: 'The Dutch Golden Age Collector',
      desc: 'Low horizons, big weather, warm brown interiors lit by one window. You like the seventeenth century at its most domestic and most exacting.',
      proto: { 'sg:bar': .6, 'pd:old': 1, 'pa:dark': .7, 'su:lan': .4, 'cx:calm': .5 },
      filter: { style: 'Baroque', period: '17th' },
      url: '/collections/style-baroque/period_17th', label: '17th-century Baroque paintings' },
    { id: 'baroque-dramatist', name: 'The Baroque Dramatist',
      desc: 'You want the spotlight and the shadow it cuts. Strong diagonals, a single hard light source and a scene caught at its loudest second.',
      proto: { 'sg:bar': 1, 'pa:dark': 1, 'su:rel': .5, 'pd:old': .6, 'cx:busy': .3 },
      filter: { style: 'Baroque', subject: 'religion' },
      url: '/collections/style-baroque/subject_religion', label: 'Baroque religious paintings' },
    { id: 'rococo-aesthete', name: 'The Rococo Aesthete',
      desc: 'Pale rose, powder blue, silk and a certain amount of mischief. You read a painting the way you read a room: for charm, ornament and ease.',
      proto: { 'sg:bar': .8, 'pa:light': 1, 'pd:old': .5, 'su:por': .4, 'cx:calm': .3 },
      filter: { style: 'Rococo' },
      url: '/collections/style-rococo', label: 'Rococo paintings' },
    { id: 'realist-observer', name: 'The Realist Observer',
      desc: 'No myth, no flourish, just people and places as they actually were. You value honest drawing and a painter who looked long before lifting the brush.',
      proto: { 'sg:rea': 1, 'su:por': .4, 'pd:c19': .6, 'cx:calm': .4, 'pa:dark': .2 },
      filter: { style: 'Realism' },
      url: '/collections/style-realism', label: 'Realist paintings' },
    { id: 'botanical-naturalist', name: 'The Botanical Naturalist',
      desc: 'Flowers, fruit, branches and the quiet discipline of painting them well. You like a canvas that brings the garden indoors without shouting about it.',
      proto: { 'su:bot': 1, 'cx:calm': .4, 'pa:light': .4, 'sg:rea': .3 },
      filter: { subject: 'botanicals' },
      url: '/collections/botanical-paintings', label: 'botanical paintings' },
    { id: 'coastal-dreamer', name: 'The Coastal Dreamer',
      desc: 'Water, sky and the line where they meet. Cool blues and open space do more for you than any interior scene.',
      proto: { 'su:sea': 1, 'pa:cool': .8, 'sg:imp': .3, 'pa:light': .3 },
      filter: { subject: 'seascapes' },
      url: '/collections/subject-seascapes', label: 'seascapes' },
    { id: 'sacred-art-devotee', name: 'The Sacred Art Devotee',
      desc: 'Altarpieces, annunciations, saints in gold. You are moved by paintings built to be looked at for a lifetime rather than an afternoon.',
      proto: { 'su:rel': 1, 'pd:old': .6, 'sg:ren': .5, 'pa:dark': .3 },
      filter: { subject: 'religion' },
      url: '/collections/subject-religion', label: 'religious paintings' },
    { id: 'modern-expressionist', name: 'The Modern Expressionist',
      desc: 'Colour off the leash and a mark you can see the hand in. The twentieth century suits you: feeling first, likeness second.',
      proto: { 'sg:mod': 1, 'pd:c20': 1, 'cx:busy': .6, 'pa:warm': .2 },
      filter: { style: 'Expressionism' },
      url: '/collections/style-expressionism', label: 'Expressionist paintings' },
    { id: 'neoclassical-purist', name: 'The Neoclassical Purist',
      desc: 'Clean contour, balanced composition, classical calm. You want order on the wall, a painting that settles a room instead of stirring it.',
      proto: { 'sg:rea': .7, 'pd:old': .9, 'cx:calm': .8, 'su:por': .4, 'pa:light': .4 },
      filter: { style: 'Neoclassicism' },
      url: '/collections/style-neoclassicism', label: 'Neoclassical paintings' },
    { id: 'grand-tour-wanderer', name: 'The Grand-Tour Wanderer',
      desc: 'Ruins, harbours, cathedral squares at golden hour, seen with the eighteenth-century traveller’s eye. You buy a painting the way you would keep a place.',
      proto: { 'sg:rom': .9, 'su:arc': .8, 'su:lan': .5, 'pd:old': .3, 'pa:warm': .4 },
      filter: { style: 'Romanticism', subject: 'architectural' },
      url: '/collections/style-romanticism/subject_architectural', label: 'Romantic architectural paintings' }
  ];
  var ARCH_BY_ID = {}; ARCH.forEach(function (a) { ARCH_BY_ID[a.id] = a; });

  var ROOMS = {
    living: { label: 'Living room', note: 'a wall people sit in front of, so scale and presence matter more than fine detail' },
    bedroom: { label: 'Bedroom', note: 'the last thing you see at night, so we lean calmer and lighter here' },
    dining: { label: 'Dining room', note: 'lit warm and looked at across a table, where richer colour reads best' },
    office: { label: 'Office', note: 'seen up close all day, so detail and a steady composition pay off' },
    entryway: { label: 'Entryway', note: 'four seconds of attention, so one strong image beats a busy one' }
  };
  var ORIENTS = { landscape: 'h', portrait: 'v', square: 's', any: '' };

  /* ------------------------------------------------------------------ utils */
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function el(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
  function money(v) { return '$' + (Math.round(v * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function nfmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function rng(seedStr) { var h = 2166136261 >>> 0; for (var i = 0; i < seedStr.length; i++) { h ^= seedStr.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; } return function () { h += 0x6D2B79F5; var t = h; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }

  function rgb2hsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, h = 0, s = 0;
    if (mx !== mn) {
      var d = mx - mn;
      s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      if (mx === r) h = ((g - b) / d + (g < b ? 6 : 0));
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return [h, s, l];
  }
  function parsePalette(c) {
    if (!c) return null;
    var out = [], parts = String(c).split(','), tot = 0;
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split(':'), hex = kv[0].replace('#', '');
      if (hex.length !== 6) continue;
      var n = parseInt(hex, 16);
      if (isNaN(n)) continue;
      var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
      var hsl = rgb2hsl(r, g, b), pct = parseFloat(kv[1]);
      if (!isFinite(pct)) pct = 100 / parts.length;
      out.push({ hex: hex, h: hsl[0], s: hsl[1], l: hsl[2], pct: pct });
      tot += pct;
    }
    if (!out.length || tot <= 0) return null;
    out.forEach(function (o) { o.w = o.pct / tot; });
    return out;
  }
  function hueWarm(h) {
    if (h <= 60) return 1;
    if (h < 105) return 1 - (h - 60) / 45;
    if (h < 150) return -(h - 105) / 45;
    if (h < 260) return -1;
    if (h < 300) return -1 + (h - 260) / 40;
    return (h - 300) / 60;
  }

  /* feature map of a row; each family sums to <= 1 */
  function feat(row) {
    var f = {}, i;
    for (i = 0; i < KEYS.length; i++) f[KEYS[i]] = 0;
    var g = SG[row[Y]];
    if (g) f['sg:' + g] = 1;
    var subs = String(row[S] || '').split('|'), hit = [];
    for (i = 0; i < subs.length; i++) { var k = SU[subs[i]]; if (k && hit.indexOf(k) < 0) hit.push(k); }
    for (i = 0; i < hit.length; i++) f['su:' + hit[i]] = 1 / hit.length;
    var j = String(row[J] || '');
    if (j === '17th' || j === '18th' || j === '16th' || j === '15th') f['pd:old'] = 1;
    else if (j === '19th') f['pd:c19'] = 1;
    else if (/^\d{4}$/.test(j)) f['pd:c20'] = 1;
    var pal = parsePalette(row[C]);
    if (pal) {
      var warm = 0, lum = 0, ent = 0;
      for (i = 0; i < pal.length; i++) {
        warm += hueWarm(pal[i].h) * pal[i].s * pal[i].w;
        lum += pal[i].l * pal[i].w;
        if (pal[i].w > 0) ent -= pal[i].w * Math.log(pal[i].w);
      }
      warm = clamp(warm * 1.7, -1, 1);
      f['pa:warm'] = Math.max(0, warm); f['pa:cool'] = Math.max(0, -warm);
      var v = clamp((lum - 0.46) * 2.6, -1, 1);
      f['pa:light'] = Math.max(0, v); f['pa:dark'] = Math.max(0, -v);
      var hn = ent / Math.log(Math.max(2, pal.length));
      var busy = clamp((hn - 0.72) / 0.22, 0, 1);
      f['cx:busy'] = busy; f['cx:calm'] = 1 - busy;
    }
    return f;
  }

  /* ------------------------------------------------------------------ state */
  var st = {
    seed: '', answers: [], pairs: [], W: {}, evid: {}, keyEvid: {},
    room: '', orient: '', arch: null, pool: [], shown: {}, chips: {}, rows60: [], count: 0
  };
  function resetModel() {
    KEYS.forEach(function (k) { st.W[k] = 0; st.keyEvid[k] = 0; });
    FAMS.forEach(function (g) { st.evid[g] = 0; });
    st.shown = {};
  }

  function hashRead() {
    var h = location.hash.replace(/^#/, ''), o = {};
    h.split('&').forEach(function (p) { if (!p) return; var i = p.indexOf('='); if (i < 0) return; o[decodeURIComponent(p.slice(0, i))] = decodeURIComponent(p.slice(i + 1)); });
    return o;
  }
  function hashWrite(o) {
    var s = Object.keys(o).filter(function (k) { return o[k] !== '' && o[k] != null; })
      .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(o[k]); }).join('&');
    try { history.replaceState(null, '', location.pathname + location.search + (s ? '#' + s : '')); } catch (e) { }
  }
  function track(ev, params) {
    try {
      if (window.ArtSeeCatalog && ArtSeeCatalog.track) return ArtSeeCatalog.track(ev, params);
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev, tool: 'art-style-quiz' };
      for (var k in params) o[k] = params[k];
      window.dataLayer.push(o);
    } catch (e) { }
  }

  /* --------------------------------------------------------------- pairing */
  function leastCertainFamily() {
    var best = null, bv = Infinity;
    for (var i = 0; i < FAMS.length; i++) {
      var g = FAMS[i], r = st.evid[g] / TARGET[g];
      if (r < bv - 1e-9) { bv = r; best = g; }
    }
    return best;
  }
  function crossSep(a, b, skipFam) {
    var d = 0;
    for (var i = 0; i < KEYS.length; i++) {
      var k = KEYS[i];
      if (KEYFAM[k] === skipFam) continue;
      d += Math.abs(a.f[k] - b.f[k]);
    }
    return d;
  }
  function topBy(score, n) {
    var out = [];
    for (var i = 0; i < st.pool.length; i++) {
      var c = st.pool[i];
      if (st.shown[c.row[H]]) continue;
      var s = score(c);
      if (out.length < n) { out.push({ c: c, s: s }); out.sort(function (x, y) { return y.s - x.s; }); }
      else if (s > out[n - 1].s) { out[n - 1] = { c: c, s: s }; out.sort(function (x, y) { return y.s - x.s; }); }
    }
    return out.map(function (o) { return o.c; });
  }
  function pickPair() {
    var g = leastCertainFamily(), keys = FAM[g], A1, B1;
    if (g === 'sg' || g === 'su' || g === 'pd') {
      var order = keys.slice().sort(function (a, b) { return (st.keyEvid[a] - st.keyEvid[b]) || (keys.indexOf(a) - keys.indexOf(b)); });
      var ka = order[0], kb = order[1];
      A1 = topBy(function (c) { var v = c.f[ka]; for (var i = 0; i < keys.length; i++) if (keys[i] !== ka) v -= 0.5 * c.f[keys[i]]; return v + c.jitter * 1e-3; }, 12);
      B1 = topBy(function (c) { var v = c.f[kb]; for (var i = 0; i < keys.length; i++) if (keys[i] !== kb) v -= 0.5 * c.f[keys[i]]; return v + c.jitter * 1e-3; }, 12);
    } else {
      var kp = keys[0], kn = keys[1];
      A1 = topBy(function (c) { return c.f[kp] - c.f[kn] + c.jitter * 1e-3; }, 12);
      B1 = topBy(function (c) { return c.f[kn] - c.f[kp] + c.jitter * 1e-3; }, 12);
    }
    var best = null, bs = Infinity;
    for (var i = 0; i < A1.length; i++) for (var j = 0; j < B1.length; j++) {
      if (A1[i].row[H] === B1[j].row[H]) continue;
      var s = crossSep(A1[i], B1[j], g) - 0.001 * (A1[i].jitter + B1[j].jitter);
      if (s < bs) { bs = s; best = [A1[i], B1[j]]; }
    }
    if (!best) {
      var fb = topBy(function (c) { return c.jitter; }, 2);
      if (fb.length < 2) return null;
      best = fb;
    }
    if (best[0].jitter > best[1].jitter) best = [best[1], best[0]];
    st.shown[best[0].row[H]] = 1; st.shown[best[1].row[H]] = 1;
    return { fam: g, a: best[0], b: best[1] };
  }
  function applyAnswer(pair, ans) {
    var fa = pair.a.f, fb = pair.b.f, X, Yy;
    if (ans === 2) {
      for (var g0 = 0; g0 < FAMS.length; g0++) {
        var g = FAMS[g0], e = 0;
        for (var i = 0; i < FAM[g].length; i++) { var k = FAM[g][i], d = Math.abs(fa[k] - fb[k]); e += d; st.keyEvid[k] += 0.5 * d; }
        st.evid[g] += 0.5 * e;
      }
      return;
    }
    X = ans === 0 ? fa : fb; Yy = ans === 0 ? fb : fa;
    for (var gi = 0; gi < FAMS.length; gi++) {
      var gg = FAMS[gi], ev = 0;
      for (var m = 0; m < FAM[gg].length; m++) {
        var kk = FAM[gg][m], d2 = X[kk] - Yy[kk];
        st.W[kk] += d2; st.keyEvid[kk] += Math.abs(d2); ev += Math.abs(d2);
      }
      st.evid[gg] += ev;
    }
  }
  function scoreArchetypes() {
    var Wn = {};
    KEYS.forEach(function (k) { Wn[k] = st.W[k] / Math.max(1, st.evid[KEYFAM[k]]); });
    var best = ARCH[0], bs = -Infinity;
    for (var i = 0; i < ARCH.length; i++) {
      var s = 0, p = ARCH[i].proto;
      for (var k in p) s += p[k] * (Wn[k] || 0);
      if (s > bs + 1e-9) { bs = s; best = ARCH[i]; }
    }
    return best;
  }

  /* ------------------------------------------------------------------- DOM */
  var stage = root.querySelector('[data-asq-stage]');
  var progress = root.querySelector('[data-asq-progress]');
  var emailBox = root.querySelector('[data-asq-email]');

  function setProgress(n, total) {
    if (!progress) return;
    if (!n) { progress.hidden = true; return; }
    progress.hidden = false;
    progress.querySelector('[data-asq-bar] i').style.width = (n / total * 100) + '%';
    progress.querySelector('[data-asq-step]').textContent = 'Question ' + n + ' of ' + total;
  }
  function clearStage() { while (stage.firstChild) stage.removeChild(stage.firstChild); }

  function cardFor(cand, onPick) {
    var b = el('button', 'asq-pick');
    b.type = 'button';
    var row = cand.row;
    var im = el('span', 'asq-pick__img');
    var img = new Image();
    img.loading = 'lazy'; img.decoding = 'async';
    img.alt = row[T] + ' by ' + row[A];
    img.src = ArtSeeCatalog.imageUrl(row, 600);
    im.appendChild(img);
    b.appendChild(im);
    var cap = el('span', 'asq-pick__cap');
    cap.appendChild(el('strong', null, row[T]));
    cap.appendChild(el('span', null, row[A]));
    b.appendChild(cap);
    b.addEventListener('click', onPick);
    return b;
  }

  function renderRound() {
    var n = st.answers.length;
    if (n >= ROUNDS) return renderPractical();
    var pair = st.pairs[n];
    if (!pair) { pair = pickPair(); if (!pair) return renderPractical(); st.pairs[n] = pair; }
    clearStage();
    setProgress(n + 1, ROUNDS + 2);
    var w = el('div', 'asq-round');
    w.appendChild(el('h2', 'asq-q', 'Which one would you rather live with?'));
    var g = el('div', 'asq-pair');
    g.appendChild(cardFor(pair.a, function () { answer(0); }));
    g.appendChild(cardFor(pair.b, function () { answer(1); }));
    w.appendChild(g);
    var skip = el('button', 'asq-skip', 'Neither, really');
    skip.type = 'button';
    skip.addEventListener('click', function () { answer(2); });
    w.appendChild(skip);
    if (n > 0) {
      var back = el('button', 'asq-back', '← Back');
      back.type = 'button';
      back.addEventListener('click', function () { st.answers.pop(); replay(); renderRound(); });
      w.appendChild(back);
    }
    stage.appendChild(w);
    stage.focus({ preventScroll: true });
  }
  function answer(a) {
    applyAnswer(st.pairs[st.answers.length], a);
    st.answers.push(a);
    syncHash();
    renderRound();
  }
  function replay() {
    resetModel();
    var kept = st.answers.slice();
    st.pairs = [];
    for (var i = 0; i < kept.length; i++) {
      var p = pickPair();
      if (!p) { st.answers = kept.slice(0, i); break; }
      st.pairs[i] = p;
      applyAnswer(p, kept[i]);
    }
    syncHash();
  }

  function renderPractical() {
    clearStage();
    if (!st.room) {
      setProgress(ROUNDS + 1, ROUNDS + 2);
      var w = el('div', 'asq-round asq-round--opts');
      w.appendChild(el('h2', 'asq-q', 'Which room is it for?'));
      var g = el('div', 'asq-opts');
      Object.keys(ROOMS).forEach(function (k) {
        var b = el('button', 'asq-opt', ROOMS[k].label); b.type = 'button';
        b.addEventListener('click', function () { st.room = k; syncHash(); renderPractical(); });
        g.appendChild(b);
      });
      w.appendChild(g);
      stage.appendChild(w);
      return;
    }
    if (!st.orient) {
      setProgress(ROUNDS + 2, ROUNDS + 2);
      var w2 = el('div', 'asq-round asq-round--opts');
      w2.appendChild(el('h2', 'asq-q', 'What shape fits the wall?'));
      var g2 = el('div', 'asq-opts');
      [['landscape', 'Landscape (wider than tall)'], ['portrait', 'Portrait (taller than wide)'],
      ['square', 'Square'], ['any', 'Any shape is fine']].forEach(function (p) {
        var b = el('button', 'asq-opt', p[1]); b.type = 'button';
        b.addEventListener('click', function () { st.orient = p[0]; syncHash(); showResult(); });
        g2.appendChild(b);
      });
      w2.appendChild(g2);
      stage.appendChild(w2);
      return;
    }
    showResult();
  }

  /* ---------------------------------------------------------------- result */
  function baseFilter() {
    var a = st.arch, o = { limit: 60, seed: st.seed };
    for (var k in a.filter) o[k] = a.filter[k];
    var oc = ORIENTS[st.orient || 'any'];
    if (oc) o.orientation = oc;
    if (st.chips.landscapes) { o.subject = 'landscapes'; }
    if (st.chips.portraits) { o.subject = 'portraits'; }
    return o;
  }
  /* ArtSeeCatalog.filter is Promise-based (tools-catalog.js). Relax the filter step by
     step until at least 12 works come back, then count the full unlimited match so the
     "See all N" button states a real number. */
  function fetchRows() {
    var o = baseFilter();
    return ArtSeeCatalog.filter(o)
      .then(function (rows) {
        if (rows.length >= 12 || !o.period) return rows;
        delete o.period; return ArtSeeCatalog.filter(o);
      })
      .then(function (rows) {
        if (rows.length >= 12 || !o.subject || !o.style) return rows;
        delete o.subject; return ArtSeeCatalog.filter(o);
      })
      .then(function (rows) {
        if (rows.length >= 12 || !o.orientation) return rows;
        delete o.orientation; return ArtSeeCatalog.filter(o);
      })
      .then(function (rows) {
        return ArtSeeCatalog.filter({
          style: o.style, subject: o.subject, period: o.period,
          orientation: o.orientation, limit: 0
        }).then(function (all) {
          st.count = all.length || rows.length;
          return rows;
        }, function () { st.count = rows.length; return rows; });
      });
  }
  function rankRows(rows) {
    var chips = st.chips, scored = rows.map(function (r) {
      var f = feat(r), s = 0;
      if (chips.warmer) s += (f['pa:warm'] - f['pa:cool']) * 2;
      if (chips.cooler) s += (f['pa:cool'] - f['pa:warm']) * 2;
      if (chips.traditional) s += (f['pd:old'] * 2 + f['pd:c19'] * 0.5 - f['pd:c20'] * 2);
      if (chips.modern) s += (f['pd:c20'] * 2 + f['pd:c19'] * 0.5 - f['pd:old'] * 2);
      if (st.room === 'bedroom') s += f['cx:calm'] * 0.4 + f['pa:light'] * 0.3;
      if (st.room === 'dining') s += f['pa:warm'] * 0.4;
      if (st.room === 'entryway') s += f['cx:calm'] * 0.3;
      return { r: r, s: s };
    });
    var any = false;
    for (var k in chips) if (chips[k]) any = true;
    if (any || st.room) scored.sort(function (a, b) { return b.s - a.s; });
    return scored.slice(0, 12).map(function (o) { return o.r; });
  }

  function workCard(row) {
    var a = el('a', 'asq-card');
    a.href = ArtSeeCatalog.pdpUrl(row);
    a.addEventListener('click', function () { track('tool_cta_click', { handle: row[H], archetype: st.arch.id }); });
    var im = el('span', 'asq-card__img');
    var img = new Image();
    img.loading = 'lazy'; img.decoding = 'async';
    img.alt = row[T] + ' by ' + row[A] + ', hand-painted oil reproduction';
    img.src = ArtSeeCatalog.imageUrl(row, 400);
    im.appendChild(img); a.appendChild(im);
    a.appendChild(el('strong', 'asq-card__t', row[T]));
    a.appendChild(el('span', 'asq-card__a', row[A]));
    a.appendChild(el('span', 'asq-card__p', 'from ' + money(row[P])));
    return a;
  }

  var CHIPS = [
    ['warmer', 'Warmer'], ['cooler', 'Cooler'], ['traditional', 'More traditional'],
    ['modern', 'More modern'], ['landscapes', 'Landscapes only'], ['portraits', 'Portraits only']
  ];
  var EXCL = { warmer: 'cooler', cooler: 'warmer', traditional: 'modern', modern: 'traditional', landscapes: 'portraits', portraits: 'landscapes' };

  function showResult(scroll) {
    if (!st.arch) st.arch = scoreArchetypes();
    syncHash();
    clearStage();
    setProgress(0);
    track('tool_result', { archetype: st.arch.id, room: st.room, orientation: st.orient });

    var w = el('div', 'asq-result');
    w.appendChild(el('p', 'asq-result__eyebrow', 'Your art style is'));
    w.appendChild(el('h2', 'asq-result__name', st.arch.name));
    w.appendChild(el('p', 'asq-result__desc', st.arch.desc));
    if (st.room && ROOMS[st.room]) {
      w.appendChild(el('p', 'asq-result__room', ROOMS[st.room].label + ': ' + ROOMS[st.room].note + '.'));
    }

    var chipRow = el('div', 'asq-chips');
    chipRow.appendChild(el('span', 'asq-chips__lbl', 'Refine:'));
    CHIPS.forEach(function (c) {
      var b = el('button', 'asq-chip' + (st.chips[c[0]] ? ' is-on' : ''), c[1]);
      b.type = 'button';
      b.setAttribute('aria-pressed', st.chips[c[0]] ? 'true' : 'false');
      b.addEventListener('click', function () {
        st.chips[c[0]] = !st.chips[c[0]];
        if (st.chips[c[0]] && EXCL[c[0]]) st.chips[EXCL[c[0]]] = false;
        showResult(true);
      });
      chipRow.appendChild(b);
    });
    w.appendChild(chipRow);

    var grid = el('div', 'asq-grid');
    grid.setAttribute('data-asq-grid', '');
    grid.appendChild(el('p', 'asq-empty', 'Finding your paintings…'));
    w.appendChild(grid);

    var act = el('div', 'asq-actions');
    var all = el('a', 'asq-btn asq-btn--primary', 'See all ' + st.arch.label + ' for you');
    all.href = st.arch.url;
    all.addEventListener('click', function () { track('tool_cta_click', { archetype: st.arch.id, target: 'collection' }); });
    act.appendChild(all);
    var share = el('button', 'asq-btn asq-btn--outline', 'Share your result');
    share.type = 'button';
    share.addEventListener('click', function () { shareCard(share); });
    act.appendChild(share);
    var again = el('button', 'asq-btn asq-btn--ghost', 'Take it again');
    again.type = 'button';
    again.addEventListener('click', function () { restart(); });
    act.appendChild(again);
    w.appendChild(act);

    stage.appendChild(w);
    if (emailBox) emailBox.hidden = false;
    if (scroll) w.scrollIntoView({ behavior: 'smooth', block: 'start' });

    var token = ++resultToken;
    fetchRows().then(function (pool) {
      if (token !== resultToken) return;
      var rows = rankRows(pool);
      st.rows60 = rows;
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      if (!rows.length) grid.appendChild(el('p', 'asq-empty', 'No matches with those refinements. Turn one off.'));
      rows.forEach(function (r) { grid.appendChild(workCard(r)); });
      all.textContent = 'See all ' + (st.count ? nfmt(st.count) + ' ' : '') + st.arch.label + ' for you';
      root.setAttribute('data-asq-ready', '1');
    }, function () {
      if (token !== resultToken) return;
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      grid.appendChild(el('p', 'asq-empty', 'The catalogue index did not answer. Refresh the page to see your picks.'));
    });
  }
  var resultToken = 0;

  function restart() {
    st.answers = []; st.pairs = []; st.room = ''; st.orient = ''; st.arch = null; st.chips = {};
    st.seed = Date.now().toString(36);
    resetModel();
    if (emailBox) emailBox.hidden = true;
    syncHash();
    renderRound();
  }

  function syncHash() {
    var o = { s: st.seed };
    if (st.answers.length) o.q = st.answers.join('');
    if (st.room) o.room = st.room;
    if (st.orient) o.o = st.orient;
    if (st.arch) o.r = st.arch.id;
    hashWrite(o);
  }

  /* ----------------------------------------------------------- share canvas */
  function shareCard(btn) {
    var old = btn.textContent;
    btn.disabled = true; btn.textContent = 'Building…';
    var cv = document.createElement('canvas');
    cv.width = 1200; cv.height = 630;
    var cx = cv.getContext('2d');
    cx.fillStyle = '#FEFBF6'; cx.fillRect(0, 0, 1200, 630);
    cx.fillStyle = '#5C4033'; cx.font = '700 22px Inter, Helvetica, Arial, sans-serif';
    cx.fillText('YOUR ART STYLE IS', 64, 92);
    cx.fillStyle = '#000'; cx.font = '800 54px Inter, Helvetica, Arial, sans-serif';
    cx.fillText(st.arch.name, 64, 158);
    cx.fillStyle = '#4B5563'; cx.font = '400 22px Inter, Helvetica, Arial, sans-serif';
    cx.fillText('art-and-see.com  ·  free 2-minute art style quiz', 64, 566);
    var picks = st.rows60.slice(0, 3), done = 0;
    if (!picks.length) return finish();
    picks.forEach(function (r, i) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var bw = 320, bh = 300, x = 64 + i * 352, y = 210;
        var sc = Math.min(bw / img.width, bh / img.height);
        var dw = img.width * sc, dh = img.height * sc;
        cx.fillStyle = '#F4EBE0'; cx.fillRect(x, y, bw, bh);
        cx.drawImage(img, x + (bw - dw) / 2, y + (bh - dh) / 2, dw, dh);
        if (++done === picks.length) finish();
      };
      img.onerror = function () { if (++done === picks.length) finish(); };
      img.src = ArtSeeCatalog.imageUrl(r, 400);
    });
    function finish() {
      try {
        cv.toBlob(function (bl) {
          if (!bl) { btn.disabled = false; btn.textContent = old; return; }
          var a = document.createElement('a');
          a.href = URL.createObjectURL(bl);
          a.download = 'art-see-' + st.arch.id + '.png';
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
          btn.disabled = false; btn.textContent = 'Saved ✓';
          setTimeout(function () { btn.textContent = old; }, 2500);
          track('tool_cta_click', { archetype: st.arch.id, target: 'share' });
        }, 'image/png');
      } catch (e) { btn.disabled = false; btn.textContent = old; }
    }
  }

  /* ------------------------------------------------------------------ boot */
  function buildPool(rows) {
    var r = rng(st.seed + '|pool'), scored = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row[C] || !row[Y] || !row[10]) continue;
      scored.push({ row: row, k: r() });
    }
    scored.sort(function (a, b) { return a.k - b.k; });
    var pool = scored.slice(0, 900);
    st.pool = pool.map(function (o, i) { return { row: o.row, f: feat(o.row), jitter: i / pool.length }; });
  }

  function start() {
    var startBtn = root.querySelector('[data-asq-start]');
    if (startBtn) startBtn.addEventListener('click', function () {
      root.querySelector('[data-asq-intro]').hidden = true;
      track('tool_open', {});
      restart();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    root.querySelectorAll('[data-asq-jump]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('data-asq-jump');
        if (!ARCH_BY_ID[id]) return;
        ev.preventDefault();
        openArchetype(id);
      });
    });
    window.addEventListener('hashchange', function () {
      var h = hashRead();
      if (h.r && ARCH_BY_ID[h.r] && (!st.arch || st.arch.id !== h.r)) openArchetype(h.r);
    });
    var h = hashRead();
    if (h.s) st.seed = h.s; else st.seed = Date.now().toString(36);
    if (h.room && ROOMS[h.room]) st.room = h.room;
    if (h.o && ORIENTS[h.o] !== undefined) st.orient = h.o;
    if (h.q && /^[012]+$/.test(h.q)) {
      root.querySelector('[data-asq-intro]').hidden = true;
      st.answers = h.q.split('').map(Number).slice(0, ROUNDS);
      replay();
      if (h.r && ARCH_BY_ID[h.r]) { st.arch = ARCH_BY_ID[h.r]; showResult(); }
      else if (st.answers.length >= ROUNDS) renderPractical();
      else renderRound();
      return;
    }
    if (h.r && ARCH_BY_ID[h.r]) return openArchetype(h.r);
  }
  function openArchetype(id) {
    root.querySelector('[data-asq-intro]').hidden = true;
    st.arch = ARCH_BY_ID[id];
    st.chips = {};
    if (!st.orient) st.orient = 'any';
    showResult(true);
  }

  function fail(msg) {
    clearStage();
    var p = el('p', 'asq-empty', msg);
    stage.appendChild(p);
  }

  function boot(tries) {
    tries = tries || 0;
    if (!window.ArtSeeCatalog) {
      if (tries > 60) return fail('The catalogue index did not load. Refresh the page and the quiz will run.');
      return setTimeout(function () { boot(tries + 1); }, 150);
    }
    ArtSeeCatalog.load('all').then(function (rows) {
      if (!rows || !rows.length) return fail('The catalogue index came back empty. Refresh to try again.');
      buildPool(rows);
      resetModel();
      start();
    }).catch(function () {
      fail('The catalogue index did not load. Refresh the page and the quiz will run.');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
